export const GETTING_BALANCE_DELAY = 60000;

export enum PlayStatus {
  REGULAR = 'regular',
  PLAYING = 'playing',
  LOSS = 'loss',
  WIN = 'win',
}
